<template>
  <path
    d="M17.7 19.7002C18.09 19.3102 18.09 18.6802 17.7 18.2902L15 15.5902L13.59 17.0002L16.29 19.7002C16.68 20.0902 17.32 20.0902 17.7 19.7002ZM8.71 8.00021H11V13.5902L6.29 18.2902C5.9 18.6802 5.9 19.3102 6.29 19.7002C6.68 20.0902 7.31 20.0902 7.7 19.7002L12.41 15.0002C12.79 14.6202 13 14.1202 13 13.5902V8.00021H15.29C15.74 8.00021 15.96 7.46021 15.64 7.15021L12.35 3.86021C12.15 3.66021 11.84 3.66021 11.64 3.86021L8.35 7.15021C8.04 7.46021 8.26 8.00021 8.71 8.00021Z"
  />
</template>
